import { GlobalAxios } from "../axios/axios-config";

const SYNC_BENEFICIARY_ROUTE =
  process.env.REACT_APP_COLLECTOR +
  "/api/v1/IndividualBeneficiaries/SyncBeneficiary";

export interface ISyncBeneficiary {
  establishmentId: string;
  document: string;
}

export const syncBeneficiary = (params: ISyncBeneficiary) => {
  return GlobalAxios.post(SYNC_BENEFICIARY_ROUTE, params);
};
